import { ButtonLink } from '../../../components/Inputs/Buttons'
import React from 'react'
import { numberFormat } from '../../../utils/helpers/formats.helpers'

const ListaInvitados = ({invitados, setInvitados, soloLectura = true, setEstadoAgregando}) => {

    const eliminarInvitado = (dni) => {
        setInvitados(invitados.filter(invitado => invitado.dni !== dni))
        setEstadoAgregando(false)
    }

    return (
            invitados.map(invitado => <div
                    key={invitado.dni}
                    className="ps-2"
                >
                    {numberFormat(invitado.dni)} -
                    {` ${invitado.apellido}, ${invitado.nombre} `}
                     -
                    {` Edad ${invitado.edad} años`}
                    {
                        !soloLectura &&
                        <ButtonLink
                            onClick={() => eliminarInvitado(invitado.dni)}
                            color="danger"
                            className="ms-2"
                        >
                            Eliminar
                        </ButtonLink> 
                    }
                    
            </div>
        )
    )
}

export default ListaInvitados